module.exports = __webpack_public_path__ + "static/WheatFlour-31fafa7a2c53633d84640fe564499a4f.webp";